<template>
  <div>
    <list
      row-key="EmpId"
      ref="list"
      unit="员工"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="工号">
          <el-input clearable v-model="params.EmpNo" placeholder="请输入工号" />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input clearable v-model="params.EmpName" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="手机">
          <el-input clearable v-model="params.Mobile" placeholder="请输入手机" />
        </el-form-item>
        <el-form-item label="证件类型">
          <el-select v-model="params.IdType" placeholder="请选择证件类型" clearable>
            <el-option label="身份证" :value="0"></el-option>
            <el-option label="军官证" :value="1"></el-option>
            <el-option label="士兵证" :value="2"></el-option>
            <el-option label="中国护照" :value="3"></el-option>
            <el-option label="武警警官证" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号码">
          <el-input clearable v-model="params.IdNo" placeholder="请输入证件号码" />
        </el-form-item>
        <el-form-item label="职务">
          <el-input clearable v-model="params.Post" placeholder="请输入职务" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="EmpNo" label="工号" min-width="110px" />
        <el-table-column prop="EmpName" label="姓名" min-width="100px" />
        <el-table-column prop="IsTop" label="性别">
          <template slot-scope="{ row }">
            <span>{{row.Sex==0?"男":"女"}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Post" label="职务" min-width="110px" />
        <el-table-column prop="IdType" label="证件类型" min-width="100px">
          <template slot-scope="{row}">
            <span v-if="row.IdType==0">身份证</span>
            <span v-if="row.IdType==1">军官证</span>
            <span v-if="row.IdType==2">士兵证</span>
            <span v-if="row.IdType==3">中国护照</span>
            <span v-if="row.IdType==4">武警警官证</span>
          </template>
        </el-table-column>
        <el-table-column prop="IdNo" label="证件号码" min-width="170px" />
        <el-table-column prop="Mobile" label="手机" min-width="110px" />
        <el-table-column prop="Email" label="邮箱" min-width="130px" />
        <el-table-column prop="EntryDate" label="入职时间" min-width="100px">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.EntryDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="DpName" label="部门" min-width="100px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ent/emp").default,
      params: {
        EmpNo: "", //工号
        EmpName: "", //姓名
        Post: "", //职务
        Mobile: "", //手机
        IdType: null, //证件类型 0:身份证 1:军官证 2:士兵证 3:中国护照 4:武警警官证
        IdNo: "", //证件号码
        IsSales:true
      },
    };
  },
  methods: {
    delRange(ids) {
      
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>